import React, {useState, useCallback} from 'react';
import {View, TouchableOpacity, Platform} from 'react-native';
import Tooltip from 'react-native-walkthrough-tooltip';

import {images} from '../../../../../../assets/icons';
import {Text} from '../../../../../../shared/components/text';
import {DeviceSize, useDeviceSize} from '../../../../../../shared/theme/helpers';
import {Props} from './model';
import getStyles from './styles';
let timer: any = null;

export const FileItem = ({fileName, isLoading, onCloseClick, fileNumber}: Props) => {
  const {Close} = images;
  const [show, setShow] = useState(false);
  const styles = getStyles();
  const deviceSize = useDeviceSize();

  const isPlatformWebAndDesktop = deviceSize === DeviceSize.desktop && Platform.OS === 'web';

  const onTextClick = useCallback(() => {
    if (isPlatformWebAndDesktop || show) {
      return;
    }
    clearTimeout(timer);
    setShow(true);
    timer = setTimeout(() => {
      setShow(false);
    }, 5000);
  }, [deviceSize, isPlatformWebAndDesktop]);

  return (
    <View key={fileName} style={styles.file}>
      <TouchableOpacity
        testID={`request-filename-${fileNumber}-id`}
        activeOpacity={1}
        style={styles.fileTextContainer}
        onPress={onTextClick}>
        <Tooltip
          placement='bottom'
          onClose={() => setShow(false)}
          arrowStyle={styles.tooltipArrowStyle}
          tooltipStyle={styles.tooltipContainerStyle}
          childrenWrapperStyle={styles.tooltipOverlayStyle}
          contentStyle={styles.tooltipModalStyle}
          backgroundColor='transparent'
          isVisible={show}
          content={
            <Text numberOfLines={4} ellipsizeMode='tail'>
              {fileName}
            </Text>
          }>
          <Text style={styles.fileText} numberOfLines={1} ellipsizeMode='tail' title={fileName}>
            {fileName}
          </Text>
        </Tooltip>
      </TouchableOpacity>
      <TouchableOpacity
        testID={`delete-request-${fileNumber}-filename-id`}
        accessibilityLabel={'Убрать ' + fileName}
        disabled={isLoading}
        style={styles.fileRemoveIcon}
        activeOpacity={Platform.OS === 'web' ? 1 : 0.5}
        onPress={onCloseClick}>
        <Close width={13} height={13} color={styles.fileRemoveIcon.color} />
      </TouchableOpacity>
    </View>
  );
};
